//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {address} from "./axios/api";
export default {
  name: 'app',
  data(){
    return {
      show:false,
      form:{
        app_id:'6a0717cc-a512-11ec-aba2-00ff74dbfc97',//信息化
        platform:'android'
      },
      data:{}
    }
  },
  created() {
    this.getaddress()
  },
  methods:{
    getaddress(){
      address(this.form).then((res) =>{
         this.data = res.data
      })
    },
    iswx(){
        var ua = navigator.userAgent.toLowerCase();  
        if(ua.match(/MicroMessenger/i)=="micromessenger") {  
            this.show = true
        } else {
            window.location = this.data.apk_url
            //这里写下载路径
        }
    }
  },
}



// WEBPACK FOOTER //
// ./src/App.vue